query AnalyticsSalesByDeviceType($filter: AnalyticsSalesFilterInput!) {
  analyticsSales(filter: $filter) {
    currency
    salesByDeviceType {
      label
      sales
      revenue
    }
  }
}
